/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "CRCRestAPI",
            "endpoint": "https://xtcluxowcc.execute-api.us-east-2.amazonaws.com/prodtwo",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://khincj4amrgxdcjj7jowvawaba.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-oas4o775nbehjbal2kd7wi7ybi",
    "aws_cognito_identity_pool_id": "us-east-2:a5ef638f-b34e-4888-902e-0906b117451d",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_1CEGYbNeH",
    "aws_user_pools_web_client_id": "116vnmmeecsqcfsh1l8tnocuhf",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME",
        "PHONE_NUMBER"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "downloadfiles6d184-prodtwo",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
